import { object, string } from "yup";

const getValidationSchema = (t) =>
  object({
    nonCompete: string().required(t("background.validation.required")),
    nonCompeteCompany: string().when("nonCompete", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.companyRequired"))
          .min(2, t("background.validation.min2"))
          .max(100, t("background.validation.max100")),
    }),
    nonCompeteDate: string().when("nonCompete", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.dateSignedRequired"))
          .min(7, t("background.validation.min7")),
    }),
    workInjury: string().required(t("background.validation.required")),
    workInjuryDate: string().when("workInjury", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.injuryDateRequired"))
          .min(7, t("background.validation.min7")),
    }),
    workInjuryExplantation: string().when("workInjury", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.injuryExplanationRequired"))
          .min(2, t("background.validation.min2"))
          .max(250, t("background.validation.max250")),
    }),
    workmanComp: string().required(t("background.validation.required")),
    workCompInjuryDate: string().when("workmanComp", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.injuryDateRequired"))
          .min(7, t("background.validation.min7")),
    }),
    workCompExplanation: string().when("workmanComp", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.injuryExplanationRequired"))
          .min(2, t("background.validation.min2"))
          .max(250, t("background.validation.max250")),
    }),
    disability: string().required(t("background.validation.required")),
    disabilityCompany: string().when("disability", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.companyRequired"))
          .min(2, t("background.validation.min2"))
          .max(100, t("background.validation.max100")),
    }),
    disabilityAmount: string().when("disability", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.disabilityAmountRequired"))
          .max(10, t("background.validation.max10")),
    }),
    convictions: string().required(t("background.validation.required")),
    convictionsExplanation: string().when("convictions", {
      is: "yes",
      then: () =>
        string()
          .required(t("background.validation.convictionsExplanationRequired"))
          .min(2, t("background.validation.min2"))
          .max(100, t("background.validation.max100")),
    }),
  });

export { getValidationSchema };
